/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of all the linked lists available for @see {@link Synqo.Cloud.Stammdaten.Model.Api.ApiService}
 */
export class ServiceLinkLists {
    /**
     * Represents a list of linked avvs
     */
    static readonly avv: string = 'avv';
}
